import { Link } from 'elements/Link/Link'
import htmlParser, { DOMNode, domToReact, Element, HTMLReactParserOptions } from 'html-react-parser'
import { htmlContent } from 'lib/htmlContent'

import { Icon } from 'elements/Icon/Icon'

export type HTMLModuleData = { headline: string; contentLeft: string; contentRight: string }
type Props = { data: HTMLModuleData; className: string }

export const htmlModuleParserOptions: HTMLReactParserOptions = {
  replace(domNode: DOMNode) {
    if (domNode instanceof Element && domNode.attribs) {
      if (domNode.name === 'a') {
        const { href, ...rest } = domNode.attribs

        if ('download' in domNode.attribs) {
          // we style download links differntly
          return (
            <Link
              href={href}
              className={`${domNode.attribs.class} flex items-center text-red`}
              {...rest}
            >
              <Icon name="download" className="mr-4" /> {domToReact(domNode.children as DOMNode[])}
            </Link>
          )
        }

        return (
          <Link href={href} className={domNode.attribs.class} {...rest}>
            {domToReact(domNode.children as DOMNode[])}
          </Link>
        )
      }
      if (domNode.name === 'table') {
        return (
          <div
            className={`overflow-x-scroll overflow-y-scroll sm:overflow-y-hidden md:overflow-x-auto`}
            style={{ maxWidth: 'calc(100vw - 2rem)' }}
          >
            <table>{domToReact(domNode.children as DOMNode[])}</table>
          </div>
        )
      }
    }
  },
}

export const HTMLModule = ({ className, data }: Props) => {
  const left = htmlContent(data.contentLeft)
  const right = htmlContent(data.contentRight)
  const onlyRightData = data.contentRight && !data.contentLeft

  return (
    <div className={`px-4 py-6 md:px-20 md:py-16 ${className}`}>
      <h2 className="mb-6 text-3xl font-medium text-black-light md:col-span-2">{data.headline}</h2>
      <div
        className={`pdp-html-module md:grid md:gap-8 ${
          onlyRightData ? 'md:grid-cols-1' : 'md:grid-cols-2'
        }`}
      >
        <div>{htmlParser(left, htmlModuleParserOptions)}</div>
        <div>{htmlParser(right, htmlModuleParserOptions)}</div>
      </div>
    </div>
  )
}
